<mat-card appearance="outlined" style="margin-top: 2px; margin-bottom: 2px" fxLayout="column" fxFlex class="stretched-container" fxLayoutGap="5px">
  <div fxFlex="initial" fxLayout="row" class="duplicates-action-row" fxLayoutGap="5px">
    <a href="javascript:void(0);" (click)="selectAllDuplicates('first')">Select all but last</a>
    <a href="javascript:void(0);" (click)="selectAllDuplicates('last')">Select all but first</a>
    <a href="javascript:void(0);" (click)="selectAllDuplicates('deselect')">Deselect all</a>
  </div>
  <div fxFlex class="stretched-container">
    <p-table [value]="duplicatesData" [columns]="tableColumns" (onSort)="onSort()" sortField="group" dataKey="group"
           styleClass="p-datatable-sm" [resizableColumns]="true" columnResizeMode="expand"
           (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()" [expandedRowKeys]="expandedRows"
           [scrollable]="true" scrollHeight="flex" [virtualScroll]="true" [virtualScrollItemSize]="53" [lazy]="false">
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 300px">
        <col>
        <col>
        <col>
        <col>
        <col>
        <col>
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pResizableColumn *ngFor="let col of columns">
          {{col.title}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="7">No Duplicates Found</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr *ngIf="loading">
        <td *ngFor="let col of columns">
          <p-skeleton></p-skeleton>
        </td>
      </tr>

      <tr *ngIf="!loading && rowGroupMetadata[item.group]?.index === rowIndex ">
        <td colspan="7">
          <button type="button" mat-icon-button class="button-32 only-icon" style="margin-right: 10px" [pRowToggler]="item">
            <mat-icon>{{expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
          </button>
          <span class="p-text-bold p-ml-2">
            {{item.group}} - {{rowGroupMetadata[item.group].size - 1}}
            {{rowGroupMetadata[item.group].size - 1 == 1 ? 'duplicate' : 'duplicates' }}
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-item let-columns="columns">
      <tr>
        <td>
          <mat-checkbox color="primary"
                        [disabled]="!item.selected && !rowGroupMetadata[item.group].allowSelect"
                        [(ngModel)]="item.selected" (ngModelChange)="duplicateSelectionChanged(item)" style="padding-right: 10px"></mat-checkbox>

          <button type="button" style="padding: 3px; line-height: 1; min-width: auto;" mat-stroked-button class="button-32 only-icon" (click)="editContact(item.id)"
                  *ngIf="(contactService.hasPublicContactsEditAccess && item.recordType == 0)
                    || (contactService.hasPrivateContactsEditAccess && item.recordType == 1)">
            <mat-icon>create</mat-icon>
          </button>
          <span>
            {{item.firstName}} {{item.lastName}}
          </span>
        </td>
        <td>{{ item.phoneNumber  | phoneNumber }}</td>
        <td>{{ item.mobileNumber  | phoneNumber }}</td>
        <td>{{ item.faxNumber  | phoneNumber }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.companyName }} {{ item.position }}</td>
        <td>{{ item.recordType == 0 ? 'Company' : 'Private' }}</td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</mat-card>
